// extracted by css-extract-rspack-plugin
export default {"error":"_a045ab52"};